module["exports"] = [
  "Jr.",
  "Neto",
  "Filho"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pt_BR/name/suffix.js
// module id = 1767
// module chunks = 0